import {
  ContractingCompanyFilter,
  CreateContractingCompanyInput,
  UpdateContractingCompanyInput,
} from "../../routeComponents/ContractingCompanies/Utils";
import { PaginationQueryObject, QueryConfig } from "./Queries";

const contractingCompaniesQuery = (
  filter: ContractingCompanyFilter,
  paginationInput: PaginationQueryObject
): QueryConfig => {
  const query = `query getContractingCompanies(
  $filter: ContractingCompanyFilter
  $paginationInput: PaginationInput
) {
  contractingCompanies(filter: $filter, paginationInput: $paginationInput) {
    items {
      id
      name
    }
    pageInfo {
      pageNumber
      pageSize
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
}`;

  return {
    query: query,
    variables: {
      filter,
      paginationInput,
    },
  };
};

const createContractingCompanyMutation = (
  input: CreateContractingCompanyInput
) => {
  const query = `mutation createContractingCompany($input: CreateContractingCompanyInput!) {
  createContractingCompany(input: $input) {
    id
    name
  }
}`;

  return {
    query,
    variables: {
      input,
    },
  };
};

const updateContractingCompanyMutation = (
  input: UpdateContractingCompanyInput
) => {
  const query = `mutation updateContractingCompany($input: UpdateContractingCompanyInput!) {
    updateContractingCompany(input: $input) {
      id
    }
  }`;

  return {
    query,
    variables: {
      input,
    },
  };
};

export {
  contractingCompaniesQuery,
  createContractingCompanyMutation,
  updateContractingCompanyMutation,
};
